import { CountryOptionRow as e } from "./CountryOptionRow.js";
import { useId as t } from "react";
import n from "clsx";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/CountrySelector/base/CountryOptionList.tsx
function a({ countries: a, value: o, onSelect: s, label: c, className: l }) {
	let u = `country-${t()}`;
	return /* @__PURE__ */ i("fieldset", {
		className: n("min-w-0", l),
		children: [/* @__PURE__ */ r("legend", {
			className: "sr-only",
			children: c
		}), a.map((t) => /* @__PURE__ */ r(e, {
			name: u,
			country: t,
			checked: t.id === o,
			onSelect: s
		}, t.id))]
	});
}
//#endregion
export { a as CountryOptionList };
